import { render, staticRenderFns } from "./newSearch.vue?vue&type=template&id=4f47e8fe&"
import script from "./newSearch.vue?vue&type=script&lang=js&"
export * from "./newSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports